/**
 * Фрибет SNR на ноге: ставка не из кармана, выплата без возврата.
 *
 * У чужого калькулятора это галка. Здесь — тихое слово на плитке,
 * только в карточке: витрину им не грузим.
 */

export function FreeEdit({
  on,
  onToggle,
  face = 'word',
}: {
  on: boolean;
  onToggle: () => void;
  /** Стол сверху — билет FREE; плитка и пад — слово. */
  face?: 'word' | 'ticket';
}): React.ReactElement {
  return (
    <button
      type="button"
      className={`nx-free${face === 'ticket' ? ' nx-free--ticket' : ''}${on ? ' on' : ''}`}
      aria-pressed={on}
      title={on ? 'фрибет: ставка не из кармана, выплата без возврата' : 'считать ногу как фрибет'}
      aria-label={on ? 'снять фрибет' : 'фрибет'}
      onClick={(event) => {
        event.stopPropagation();
        onToggle();
      }}
    >
      {face === 'ticket' ? (
        <svg viewBox="0 0 58 22" aria-hidden="true" focusable="false">
          <path d="M8 3.5h42q4 0 4 3.2v1.4c-2.4.4-2.4 5.8 0 6.2v1.5q0 3.2-4 3.2H8q-4 0-4-3.2v-1.5c2.4-.4 2.4-5.8 0-6.2V6.7q0-3.2 4-3.2z" />
          <path className="nx-free__perf" d="M17 5.4v11.2" />
          <text x="37" y="14.2" textAnchor="middle">
            FREE
          </text>
        </svg>
      ) : (
        'фрибет'
      )}
    </button>
  );
}
